<template>
	<div class="tpbc-bootstrap-container">
		<div class="container">
			<div class="row">
				<div class="col-md-8">
					<form action="#" method="POST" @submit.prevent="processForm">
						<div class="row">
							<div class="col-md-6">
								<div class="form-group">
									<label for="">Contact:</label>
									<input type="text" name="name" v-model="form.name" class="form-control">
								</div>
								<div class="form-group">
									<label for="">Address:</label>
									<input type="text" name="name" v-model="form.address" class="form-control">
								</div>
								<div class="form-group">
									<label for="">Phone Number:</label>
									<input type="text" name="name" v-model="form.phone" class="form-control">
								</div>
							</div>
							
							<div class="col-md-6">
								<div class="form-group">
									<label for="">Company:</label>
									<input type="text" name="name" v-model="form.company" class="form-control">
								</div>
								
								<div class="form-group">
									<label for="">Zip Code:</label>
									<input type="text" name="name" v-model="form.zip" class="form-control">
								</div>
								
								<div class="form-group">
									<label for="">Email:</label>
									<input type="text" name="name" v-model="form.email" placeholder="you@domain.com" class="form-control">
								</div>
							</div>
						</div>

						<div class="row">
							<div class="col-md-12">
								<div class="form-group">
									<label for="">Book/Project Title:</label>
									<input type="text" v-model="form.book_title" class="form-control">
								</div>

								<div class="form-group">
									<label class="radio-inline">
			  							<input type="radio" value="reprint" v-model="form.book_print"> Reprint
									</label>
									<label class="radio-inline">
			  							<input type="radio" value="new" v-model="form.book_print"> New
									</label>
								</div>			
							</div>
						</div>

						<div class="row">
							<div class="col-md-6">
								<div class="form-group">
									<label for="">Text Provided as</label>
									<br>
									<label class="radio-inline">
			  							<input type="radio" value="pdf" v-model="form.text_provided"> PDF (print-ready)
									</label>
									<label class="radio-inline">
			  							<input type="radio" value="copy-to-scan" v-model="form.text_provided"> Copy to Scan to Digital
									</label>
								</div>

								<div class="form-group">
									<label for="">Page Count</label>
									<input type="text" class="form-control" v-model="form.page_count">
								</div>			
							</div>
						</div>

						<div class="row">
							<div class="col-md-12">
								<div class="form-group" v-for="(option, index) in options">
									<label for="">{{ option.title }}</label>

									<template v-if="option.type == 'input'">
										<input type="text" class="form-control">
									</template>
									
									<template v-if="option.type == 'textarea'">
										<textarea class="form-control"></textarea>
									</template>
									
									<select v-if="option.type == 'select'">
										<option value="">Please select</option>
										<option v-for="field in getFields(option.id)" :value="field.id">
											{{ field.title }}
										</option>
									</select>
								</div>
							</div>
						</div>

						<div class="row">
							<div class="col-md-12">
								<div class="form-group">
									<button type="submit" class="btn btn-success">Submit</button>
								</div>
							</div>
						</div>
					</form>
				</div>
			</div>
			
		</div>
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
				form: {
					name: '',
					company: '',
					address: '',
					zip: '',
					phone: '',
					email: '',
					book_title: '',
					book_print: 'new',
					text_provided: 'pdf',
					page_count: 0
				},

				options: [],
				fields: [],

				options_answered: []
			}
		},

		mounted() {
			this.getOptions();
		},

		methods: {
			getOptions() {
				var $vm = this;

				jQuery.ajax({
					url: ajaxurl,
					type: 'POST',
					data: {
						action: 'get_categories'
					}
				}).done((response) => {
					$vm.options = response;
				}).fail((response) => {
					console.log('Error: ' + response);
				});
			},

			getFields(category_id) {
				var $vm = this;
				var data = []

				jQuery.ajax({
					url: ajaxurl,
					type: 'POST',
					async: false,
					data: {
						action: 'get_option',
						id: category_id
					}
				}).done((response) => {
					data = response;
				}).fail((response) => {
					console.log('Error: ' + response);
				});

				return data;
			},

			processForm() {
				var $vm = this;

				jQuery.ajax({
					url: ajaxurl,
					type: 'POST',
					data: {
						action: 'process_form',
						form: this.form
					}
				}).done((response) => {
					$vm.options = response;
				}).fail((response) => {
					console.log('Error: ' + response);
				});
			}
		}
	}
</script>


// WEBPACK FOOTER //
// Form.vue?2a14f43b